/**
 * mwApp.sets module <br>
 * Work with category sets, categories and subcategories: show/add/edit/remove
 *
 * @namespace mwApp/sets
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/sets
 * @see mwApp/sets
 *
 * @ngdoc config
 * @name mwApp/sets.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /sets/:type
     */
    .state('app.sets', {
      abstract: true,
      url: '/sets',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/sets.controller:SetsCtrl}
     * @name /sets/tv
     * @memberof mwApp/sets.config:ConfigRoutes
     */
    .state('app.sets.tv', {
      url: '/:type',
      templateUrl: 'components/sets/views/sets.html',
      controller: 'SetsCtrl as vm',
      label: '{{::type | entitytype}} Categories',
      access: 'viewTvChannelCategory',
      resolve: {
        type: /* @ngInject */ function ($transition$) { // pckg resolved in parent state above
          const { type } = $transition$.params()
          return type
        }
      }
    })

    /**
     * controller {@link mwApp/sets.controller:SetsCtrl}
     * @name /sets/radio
     * @memberof mwApp/sets.config:ConfigRoutes
     */
    .state('app.sets.radio', {
      url: '/:type',
      templateUrl: 'components/sets/views/sets.html',
      controller: 'SetsCtrl as vm',
      label: '{{::type | entitytype}} Categories',
      access: '',
      resolve: {
        type: /* @ngInject */ function ($transition$) { // pckg resolved in parent state above
          const { type } = $transition$.params()
          return type
        }
      }
    })

    /**
     * controller {@link mwApp/sets.controller:SetsCtrl}
     * @name /sets/vod
     * @memberof mwApp/sets.config:ConfigRoutes
     */
    .state('app.sets.vod', {
      url: '/:type',
      templateUrl: 'components/sets/views/sets.html',
      controller: 'SetsCtrl as vm',
      label: '{{::type | entitytype}} Categories',
      access: 'viewVodCategory',
      resolve: {
        type: /* @ngInject */ function ($transition$) { // pckg resolved in parent state above
          const { type } = $transition$.params()
          return type
        }
      }
    })

    /**
     * controller {@link mwApp/sets.controller:SetsCtrl}
     * @name /sets/series
     * @memberof mwApp/sets.config:ConfigRoutes
     */
    .state('app.sets.series', {
      url: '/:type',
      templateUrl: 'components/sets/views/sets.html',
      controller: 'SetsCtrl as vm',
      label: '{{::type | entitytype}} Categories',
      access: 'viewTvShowCategory',
      resolve: {
        type: /* @ngInject */ function ($transition$) { // pckg resolved in parent state above
          const { type } = $transition$.params()
          return type
        }
      }
    })
}
